// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FailedContent__wrapper___faU52"};